export function SearchBtn(props) {
    return (
        <div className="dropdown add-single-bulk">
            <button
                className="btn btn-sb-search"
                id="add-single-blulk"
                onClick={props.onClickEffect && props.onClickEffect}
                disabled={props.disableProp}
            >
                {props.btnName}
            </button>
        </div>
    );
}
export function ClearBtn(props) {
    return (
        <div className="dropdown add-single-bulk">
            <button
                className="btn btn-sb-clear"
                id="add-single-blulk"
                onClick={props.onClickEffect && props.onClickEffect}
                disabled={props.disableProp}
            >
                {props.btnName}
            </button>
        </div>
    );
}

export function EditBtn(props) {
    return (
        <div className="dropdown add-single-bulk">
            <button
                className="btn btn-sb-edit"
                id="add-single-blulk"
                onClick={props.onClickEffect && props.onClickEffect}
                disabled={props.disableProp}
            >
                {props.btnName}
            </button>
        </div>
    );
}
export function DeleteBtn(props) {
    return (
        <div className="dropdown add-single-bulk">
            <button
                className="btn btn-delete "
                id="add-single-blulk"
                onClick={props.onClickEffect && props.onClickEffect}
                disabled={props.disableProp}
            >
                {props.btnName}
            </button>
        </div>
    );
}

export function UploadBtn(props) {
    return (
        <div className="dropdown add-single-bulk">
            <button
                className="btn btn-upload"
                id="add-single-blulk"
                onClick={props.onClickEffect && props.onClickEffect}
                disabled={props.disableProp}
            >
                <div className="btn-inline-item d-flex align-items-center">
                    {props.btnName}
                    &nbsp;&nbsp;
                    <i className="fa-solid fa-arrow-up-from-bracket"></i>
                </div>
            </button>
        </div>
    );
}
